module.exports = __webpack_public_path__ + "img/hr-centrifuge-B-shadow.5a21b9ac.png";